import { render, staticRenderFns } from "./charts-comparison-table.vue?vue&type=template&id=16e47d40&scoped=true&"
import script from "./charts-comparison-table.vue?vue&type=script&lang=ts&"
export * from "./charts-comparison-table.vue?vue&type=script&lang=ts&"
import style0 from "./charts-comparison-table.vue?vue&type=style&index=0&id=16e47d40&lang=scss&scoped=true&"
import style1 from "./charts-comparison-table.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e47d40",
  null
  
)

export default component.exports